// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2cSDS","ranges":"BmiRanges_ranges__2XMvs"};